module.exports = __webpack_public_path__ + "img/icon-language.7f1896ee.svg";